import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import styles from './SendButton.module.scss';

export const BUTTON_STATE = {
  SUCCESS: 'success',
  ERROR: 'error',
  LOADING: 'loading'
};

@injectIntl
export default class SendButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    buttonState: PropTypes.oneOf([
      '',
      BUTTON_STATE.SUCCESS,
      BUTTON_STATE.ERROR,
      BUTTON_STATE.LOADING
    ]).isRequired,
    message: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    loadingMessage: PropTypes.string.isRequired
  };

  static defaultProps = {
    className: ''
  };

  isDisabled() {
    return !!this.props.buttonState;
  }

  stateClass() {
    const { buttonState } = this.props;

    switch (buttonState) {
      case BUTTON_STATE.SUCCESS:
        return styles.StateSuccess;
      case BUTTON_STATE.ERROR:
        return styles.StateError;
      case BUTTON_STATE.LOADING:
        return styles.StateLoading;
      default:
        return '';
    }
  }

  buttonMessage() {
    const {
      buttonState,
      message,
      successMessage,
      errorMessage,
      loadingMessage
    } = this.props;

    switch (buttonState) {
      case BUTTON_STATE.SUCCESS:
        return successMessage;
      case BUTTON_STATE.ERROR:
        return errorMessage;
      case BUTTON_STATE.LOADING:
        return loadingMessage;
      default:
        return message;
    }
  }

  render() {
    const {
      props: { className }
    } = this;

    return (
      <input
        type="submit"
        value={this.buttonMessage()}
        className={`${styles.SubmitButton} ${className} ${this.stateClass()} `}
        disabled={this.isDisabled()}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Contact/Components/SendButton/SendButton.js